// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1s1aM","right":"styles_right__29qRI"};